define.alias("ember-power-select/components/power-select-multiple/trigger", "media/components/power-select-multiple/trigger");